import React, { useEffect, useState } from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const SubscriptionSuccess: React.FC = () => {
  const { refreshUser } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Refresh user data to get updated subscription status
    const refreshUserData = async () => {
      try {
        await refreshUser();
      } catch (error) {
        console.error('Failed to refresh user data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    // Small delay to allow billing confirmation to finish processing.
    const timer = setTimeout(refreshUserData, 2000);
    return () => clearTimeout(timer);
  }, [refreshUser]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-mango-500 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">
            Processing your payment...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 dark:bg-green-900">
          <CheckCircleIcon className="h-8 w-8 text-green-600 dark:text-green-400" />
        </div>

        <h1 className="mt-6 text-3xl font-bold text-gray-900 dark:text-white">
          Welcome to Cracked At!
        </h1>

        <p className="mt-4 text-gray-600 dark:text-gray-400">
          Your pass is active. You now have full access to all practice questions and features.
        </p>


        <div className="mt-8 space-y-4">
          <Link
            to="/dashboard"
            className="block w-full rounded-lg bg-mango-500 py-3 px-6 text-center text-sm font-medium text-white hover:bg-mango-600 transition-colors"
          >
            Go to Dashboard
          </Link>

          <Link
            to="/practice"
            className="block w-full rounded-lg border border-gray-300 dark:border-gray-600 py-3 px-6 text-center text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
          >
            Start Practicing
          </Link>
        </div>

        <div className="mt-8 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
          <h3 className="text-sm font-medium text-blue-800 dark:text-blue-200">
            What's included in your pass:
          </h3>
          <ul className="mt-2 text-sm text-blue-700 dark:text-blue-300 space-y-1">
            <li>• Access to thousands of VCE Methods and Specialist questions</li>
            <li>• Personalized difficulty matching</li>
            <li>• Performance analytics and progress tracking</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
